import { getGraphMatchingVisions } from 'affiny-core/helpers/personalityReport';
import { capitalize } from 'affiny-core/helpers/string/capitalize';
import { IPersonalityReportGraph } from 'affiny-core/modules/personalityReport/types';
import { rem, ShadowBox } from 'affiny-ui/src';
import React from 'react';
import { PersonalityReportLayerParagraph } from './PersonalityReportLayerParagraph';
import { PersonalityReportLayerTitle } from './PersonalityReportLayerTitle';

interface IPersonalityReportLayerMatchingVisions {
  graph: IPersonalityReportGraph;
}

export const PersonalityReportLayerMatchingVisions = ({
  graph,
}: IPersonalityReportLayerMatchingVisions) => {
  const matchingVisions = getGraphMatchingVisions(graph);

  return (
    <ShadowBox width={rem(544)} p="xLarge" m="auto" mb="xLarge">
      {matchingVisions.map(matchingVision => (
        <div key={matchingVision.title}>
          <PersonalityReportLayerTitle isPrimary mb="small" textAlign="center">
            {matchingVision.title}
          </PersonalityReportLayerTitle>
          <PersonalityReportLayerParagraph
            style={{
              textAlign: 'center',
            }}
          >
            {capitalize(matchingVision.description) as string}
          </PersonalityReportLayerParagraph>
        </div>
      ))}
    </ShadowBox>
  );
};
